import type { Locale } from '@skytech/types'
import { getLocalDateTime } from '@skytech/utils'

import { DEFAULT_LOCALE } from '@/app-constants'
import { useProfile } from '@/hooks/user'

export const useLocalDateTime = () => {
  const profile = useProfile()

  const formatTime = ({ date, locale }: { date: string | Date | null; locale?: Locale }) =>
    getLocalDateTime({
      date,
      locale: locale || profile?.locale || DEFAULT_LOCALE,
    })

  return { formatTime }
}
